import React, { useCallback } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { resetConfigCache } from '../../shared/api/configApi';
import { pathForState } from '../definitions';

/**
 * The shim the nine auth screens used to get from Angular, now supplied by the router.
 *
 * Each auth state in `web/app/app.js` was an inline template holding one React element plus a
 * controller that existed only to provide `navTo` and `resetCfg`. Both are here now, and the
 * screens themselves are untouched.
 *
 * `navTo` still takes a **ui-router state name**, because that is what the screens call it
 * with (`navTo('login')`, `navTo('main.root')`, `navTo('forgotPasswordSuccess', { email })`).
 * Translating rather than rewriting keeps nine components out of this change, and the names
 * have to be translated for the server's side menu anyway. See `pathForState`.
 *
 * These screens render before a tenant config exists, outside the frame, which is why nothing
 * here reaches for the CMS context. They load with the app (`../screens`).
 */
const AuthScreen = ({ Screen, pass }) => {
  const navigate = useNavigate();
  const params = useParams({ strict: false });

  const navTo = useCallback(
    (stateName, stateParams) => {
      const to = pathForState(stateName, stateParams);
      if (to) navigate({ to });
    },
    [navigate]
  );

  const extra = pass ? { [pass]: params?.[pass] } : {};
  return <Screen navTo={navTo} resetConfig={resetConfigCache} {...extra} />;
};

export default AuthScreen;
